var exports = {
  "g": "AccentColorPicker.module__errorMessage___b0VqWW",
};

module.exports = exports;
